export const WorkoutContent = {
  'exercise-type': {
    'Morning Routine': {
      'mode-time': {
        standart: '10 minutes',
        medium: '12 minutes',
        hard: '14 minutes',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cat-camel-stretch.json'),
            title: '1. Cat Camel Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '2. Jumping',
            subtitle: '45 sec',
            width: '120px',
            height: '72px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-table-balancing-pose.json'),
            title: '3. Balancing Table Pose',
            subtitle: 'x20',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '4. Leg Squats',
            subtitle: 'x12',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x10',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '6. Bicycle Crunches',
            subtitle: '30 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '7. Lunges',
            subtitle: 'x16',
            width: '120px',
            height: '110px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cat-camel-stretch.json'),
            title: '1. Cat Camel Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '2. Jumping',
            subtitle: '1 min',
            width: '120px',
            height: '72px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-table-balancing-pose.json'),
            title: '3. Balancing Table Pose',
            subtitle: 'x24',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '4. Leg Squats',
            subtitle: 'x15',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x15',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '6. Bicycle Crunches',
            subtitle: '45 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '7. Lunges',
            subtitle: 'x24',
            width: '120px',
            height: '110px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cat-camel-stretch.json'),
            title: '1. Cat Camel Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '2. Jumping',
            subtitle: '75 sec',
            width: '120px',
            height: '72px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-table-balancing-pose.json'),
            title: '3. Balancing Table Pose',
            subtitle: 'x30',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '4. Leg Squats',
            subtitle: 'x20',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '6. Bicycle Crunches',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '7. Lunges',
            subtitle: 'x30',
            width: '120px',
            height: '110px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cat-camel-stretch.json'),
            title: '1. Cat Camel Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '2. Jumping',
            subtitle: '45 sec',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-table-balancing-pose.json'),
            title: '3. Balancing Table Pose',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '4. Leg Squats',
            subtitle: 'x12',
            width: '120px',
            height: '70px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x10',
            width: '120px',
            height: '40px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '6. Bicycle Crunches',
            subtitle: '30 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '7. Lunges',
            subtitle: 'x16',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cat-camel-stretch.json'),
            title: '1. Cat Camel Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '2. Jumping',
            subtitle: '1 min',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-table-balancing-pose.json'),
            title: '3. Balancing Table Pose',
            subtitle: 'x24',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '4. Leg Squats',
            subtitle: 'x15',
            width: '120px',
            height: '70px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x15',
            width: '120px',
            height: '40px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '6. Bicycle Crunches',
            subtitle: '45 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '7. Lunges',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cat-camel-stretch.json'),
            title: '1. Cat Camel Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '2. Jumping',
            subtitle: '75 sec',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-table-balancing-pose.json'),
            title: '3. Balancing Table Pose',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '4. Leg Squats',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '6. Bicycle Crunches',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '7. Lunges',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          }
        ],
      },
    },
    'Hips, Butt and Thighs': {
      'mode-time': {
        standart: '11 minutes',
        medium: '13 minutes',
        hard: '16 minutes',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lying-leg-lifts.json'),
            title: '1. Lying Leg Lift',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank-leg-lift.json'),
            title: '2. Plank Leg Lift',
            subtitle: 'x20',
            width: '120px',
            height: '55px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '3. Leg Squats',
            subtitle: 'x15',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '4. Advanced Step-Ups',
            subtitle: 'x20',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-hip-thrust.json'),
            title: '5. Single-Leg Hip Thrust',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '6. Lunges',
            subtitle: 'x20',
            width: '120px',
            height: '100px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-squat.json'),
            title: '7. Single-Leg Squat',
            subtitle: 'x16',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lying-leg-lifts.json'),
            title: '1. Lying Leg Lift',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank-leg-lift.json'),
            title: '2. Plank Leg Lift',
            subtitle: 'x30',
            width: '120px',
            height: '55px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '3. Leg Squats',
            subtitle: 'x20',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '4. Advanced Step-Ups',
            subtitle: 'x24',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-hip-thrust.json'),
            title: '5. Single-Leg Hip Thrust',
            subtitle: 'x24',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '6. Lunges',
            subtitle: 'x24',
            width: '120px',
            height: '100px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-squat.json'),
            title: '7. Single-Leg Squat',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lying-leg-lifts.json'),
            title: '1. Lying Leg Lift',
            subtitle: 'x40',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank-leg-lift.json'),
            title: '2. Plank Leg Lift',
            subtitle: 'x40',
            width: '120px',
            height: '55px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '3. Leg Squats',
            subtitle: 'x25',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '4. Advanced Step-Ups',
            subtitle: 'x30',
            width: '120px',
            height: '80px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-hip-thrust.json'),
            title: '5. Single-Leg Hip Thrust',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '6. Lunges',
            subtitle: 'x30',
            width: '120px',
            height: '100px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-single-leg-squat.json'),
            title: '7. Single-Leg Squat',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lying-leg-lifts.json'),
            title: '1. Lying Leg Lift',
            subtitle: 'x20',
            width: '120px',
            height: '36px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank-leg-lift.json'),
            title: '2. Plank Leg Lift',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '3. Leg Squats',
            subtitle: 'x15',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '4. Advanced Step-Ups',
            subtitle: 'x20',
            width: '120px',
            height: '78px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-hip-thrust.json'),
            title: '5. Single-Leg Hip Thrust',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '6. Lunges',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-squat.json'),
            title: '7. Single-Leg Squat',
            subtitle: 'x16',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lying-leg-lifts.json'),
            title: '1. Lying Leg Lift',
            subtitle: 'x30',
            width: '120px',
            height: '36px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank-leg-lift.json'),
            title: '2. Plank Leg Lift',
            subtitle: 'x30',
            width: '120px',
            height: '50px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '3. Leg Squats',
            subtitle: 'x20',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '4. Advanced Step-Ups',
            subtitle: 'x24',
            width: '120px',
            height: '78px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-hip-thrust.json'),
            title: '5. Single-Leg Hip Thrust',
            subtitle: 'x24',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '6. Lunges',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-squat.json'),
            title: '7. Single-Leg Squat',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lying-leg-lifts.json'),
            title: '1. Lying Leg Lift',
            subtitle: 'x40',
            width: '120px',
            height: '36px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank-leg-lift.json'),
            title: '2. Plank Leg Lift',
            subtitle: 'x40',
            width: '120px',
            height: '50px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '3. Leg Squats',
            subtitle: 'x25',
            width: '120px',
            height: '75px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '4. Advanced Step-Ups',
            subtitle: 'x30',
            width: '120px',
            height: '78px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-hip-thrust.json'),
            title: '5. Single-Leg Hip Thrust',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '6. Lunges',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-single-leg-squat.json'),
            title: '7. Single-Leg Squat',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          }
        ],
      },
    },
    'Burn Belly Fat': {
      'mode-time': {
        standart: '9 minutes',
        medium: '12 minutes',
        hard: '14 minutes',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '1. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '2. Bicycle Crunch',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '3. Mountain climber',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-flutter-kicks.json'),
            title: '4. Flutter kicks',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-seated-rotation.json'),
            title: '5. Seated Rotation',
            subtitle: 'x30',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cocoon.json'),
            title: '6. Cocoon',
            subtitle: 'x30',
            width: '120px',
            height: '50px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '1. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '2. Bicycle Crunch',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '3. Mountain climber',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-flutter-kicks.json'),
            title: '4. Flutter kicks',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-seated-rotation.json'),
            title: '5. Seated Rotation',
            subtitle: 'x40',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cocoon.json'),
            title: '6. Cocoon',
            subtitle: 'x40',
            width: '120px',
            height: '50px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '1. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-bicycle-crunches.json'),
            title: '2. Bicycle Crunch',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '3. Mountain climber',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-flutter-kicks.json'),
            title: '4. Flutter kicks',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-seated-rotation.json'),
            title: '5. Seated Rotation',
            subtitle: 'x50',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cocoon.json'),
            title: '6. Cocoon',
            subtitle: 'x50',
            width: '120px',
            height: '50px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '1. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '2. Bicycle Crunch',
            subtitle: 'x20',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '3. Mountain climber',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-flutter-kicks.json'),
            title: '4. Flutter kicks',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-seated-rotation.json'),
            title: '5. Seated Rotation',
            subtitle: 'x30',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cocoon.json'),
            title: '6. Cocoon',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '1. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '2. Bicycle Crunch',
            subtitle: 'x30',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '3. Mountain climber',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-flutter-kicks.json'),
            title: '4. Flutter kicks',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-seated-rotation.json'),
            title: '5. Seated Rotation',
            subtitle: 'x40',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cocoon.json'),
            title: '6. Cocoon',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '1. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-bicycle-crunches.json'),
            title: '2. Bicycle Crunch',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '3. Mountain climber',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-flutter-kicks.json'),
            title: '4. Flutter kicks',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-seated-rotation.json'),
            title: '5. Seated Rotation',
            subtitle: 'x50',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cocoon.json'),
            title: '6. Cocoon',
            subtitle: 'x50',
            width: '120px',
            height: '40px',
          }
        ],
      },
    },
    'Full-Body Workout': {
      'mode-time': {
        standart: '15 minutes',
        medium: '18 minutes',
        hard: '22 minutes',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x10',
            width: '120px',
            height: '80px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '2. Leg Squats',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '3. Advanced Step-Ups',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '4. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '45px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x15',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '6. Mountain climber',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '7. Triceps dips',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '8. Incline Push-Up',
            subtitle: 'x25',
            width: '120px',
            height: '45px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '9. Diagonal Plank',
            subtitle: 'x20',
            width: '120px',
            height: '45px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '10. Jumping',
            subtitle: '45 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cobra-stretch.json'),
            title: '11. Cobra Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x15',
            width: '120px',
            height: '80px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '2. Leg Squats',
            subtitle: 'x25',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '3. Advanced Step-Ups',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '4. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '45px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '6. Mountain climber',
            subtitle: '90 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '7. Triceps dips',
            subtitle: 'x40',
            width: '120px',
            height: '60px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '8. Incline Push-Up',
            subtitle: 'x32',
            width: '120px',
            height: '45px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '9. Diagonal Plank',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '10. Jumping',
            subtitle: '1 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cobra-stretch.json'),
            title: '11. Cobra Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x20',
            width: '120px',
            height: '80px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-leg-squats.json'),
            title: '2. Leg Squats',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '3. Advanced Step-Ups',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-plank.json'),
            title: '4. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '45px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x25',
            width: '120px',
            height: '50px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '6. Mountain climber',
            subtitle: '2 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '7. Triceps dips',
            subtitle: 'x50',
            width: '120px',
            height: '60px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '8. Incline Push-Up',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '9. Diagonal Plank',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '10. Jumping',
            subtitle: '75 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-cobra-stretch.json'),
            title: '11. Cobra Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '40px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x10',
            width: '120px',
            height: '75px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '2. Leg Squats',
            subtitle: 'x20',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '3. Advanced Step-Ups',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '4. Plank',
            subtitle: '45 sec',
            width: '120px',
            height: '30px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x15',
            width: '120px',
            height: '30px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '6. Mountain climber',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '7. Triceps dips',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '8. Incline Push-Up',
            subtitle: 'x25',
            width: '120px',
            height: '40px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '9. Diagonal Plank',
            subtitle: 'x20',
            width: '120px',
            height: '30px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '10. Jumping',
            subtitle: '45 sec',
            width: '120px',
            height: '75px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cobra-stretch.json'),
            title: '11. Cobra Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '70px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x15',
            width: '120px',
            height: '75px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '2. Leg Squats',
            subtitle: 'x25',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '3. Advanced Step-Ups',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '4. Plank',
            subtitle: '1 min',
            width: '120px',
            height: '30px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x20',
            width: '120px',
            height: '30px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '6. Mountain climber',
            subtitle: '90 sec',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '7. Triceps dips',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '8. Incline Push-Up',
            subtitle: 'x32',
            width: '120px',
            height: '40px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '9. Diagonal Plank',
            subtitle: 'x30',
            width: '120px',
            height: '30px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '10. Jumping',
            subtitle: '1 min',
            width: '120px',
            height: '75px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cobra-stretch.json'),
            title: '11. Cobra Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '70px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '1. Burpees',
            subtitle: 'x20',
            width: '120px',
            height: '75px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-leg-squats.json'),
            title: '2. Leg Squats',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '3. Advanced Step-Ups',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-plank.json'),
            title: '4. Plank',
            subtitle: '90 sec',
            width: '120px',
            height: '30px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '5. Push Ups',
            subtitle: 'x25',
            width: '120px',
            height: '30px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '6. Mountain climber',
            subtitle: '2 min',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '7. Triceps dips',
            subtitle: 'x50',
            width: '120px',
            height: '45px',
          },
          {
            id: 8,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '8. Incline Push-Up',
            subtitle: 'x40',
            width: '120px',
            height: '40px',
          },
          {
            id: 9,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '9. Diagonal Plank',
            subtitle: 'x40',
            width: '120px',
            height: '30px',
          },
          {
            id: 10,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '10. Jumping',
            subtitle: '75 sec',
            width: '120px',
            height: '75px',
          },
          {
            id: 11,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-cobra-stretch.json'),
            title: '11. Cobra Stretch',
            subtitle: 'x5',
            width: '120px',
            height: '70px',
          }
        ],
      },
    },
    'Toned Arms and Chest': {
      'mode-time': {
        standart: '12 minutes',
        medium: '14 minutes',
        hard: '16 minutes',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '1. Push Ups',
            subtitle: 'x15',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '2. Triceps dips',
            subtitle: 'x30',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '3. Incline Push-Up',
            subtitle: 'x25',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Walk-out pushups with shoulder taps',
            subtitle: 'x8',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-to-low-plank.json'),
            title: '5. High-to-low plank',
            subtitle: 'x12',
            width: '120px',
            height: '45px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-push-ups.json'),
            title: '6. Triceps pushups',
            subtitle: 'x8',
            width: '120px',
            height: '45px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '7. Diagonal plank',
            subtitle: 'x20',
            width: '120px',
            height: '45px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '1. Push Ups',
            subtitle: 'x20',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '2. Triceps dips',
            subtitle: 'x40',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '3. Incline Push-Up',
            subtitle: 'x32',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Walk-out pushups with shoulder taps',
            subtitle: 'x10',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-to-low-plank.json'),
            title: '5. High-to-low plank',
            subtitle: 'x15',
            width: '120px',
            height: '45px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-push-ups.json'),
            title: '6. Triceps pushups',
            subtitle: 'x12',
            width: '120px',
            height: '45px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '7. Diagonal plank',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-push-ups.json'),
            title: '1. Push Ups',
            subtitle: 'x25',
            width: '120px',
            height: '50px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-dips.json'),
            title: '2. Triceps dips',
            subtitle: 'x50',
            width: '120px',
            height: '60px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-incline-push-ups.json'),
            title: '3. Incline Push-Up',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Walk-out pushups with shoulder taps',
            subtitle: 'x12',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-to-low-plank.json'),
            title: '5. High-to-low plank',
            subtitle: 'x20',
            width: '120px',
            height: '45px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-triceps-push-ups.json'),
            title: '6. Triceps pushups',
            subtitle: 'x16',
            width: '120px',
            height: '45px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-diagonal-plank.json'),
            title: '7. Diagonal plank',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '1. Push Ups',
            subtitle: 'x15',
            width: '120px',
            height: '35px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '2. Triceps dips',
            subtitle: 'x30',
            width: '120px',
            height: '45px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '3. Incline Push-Up',
            subtitle: 'x25',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Walk-out pushups with shoulder taps',
            subtitle: 'x8',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-to-low-plank.json'),
            title: '5. High-to-low plank',
            subtitle: 'x12',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-push-ups.json'),
            title: '6. Triceps pushups',
            subtitle: 'x8',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '7. Diagonal plank',
            subtitle: 'x20',
            width: '120px',
            height: '35px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '1. Push Ups',
            subtitle: 'x20',
            width: '120px',
            height: '35px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '2. Triceps dips',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '3. Incline Push-Up',
            subtitle: 'x32',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Walk-out pushups with shoulder taps',
            subtitle: 'x10',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-to-low-plank.json'),
            title: '5. High-to-low plank',
            subtitle: 'x15',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-push-ups.json'),
            title: '6. Triceps pushups',
            subtitle: 'x12',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '7. Diagonal plank',
            subtitle: 'x30',
            width: '120px',
            height: '35px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-push-ups.json'),
            title: '1. Push Ups',
            subtitle: 'x25',
            width: '120px',
            height: '35px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-dips.json'),
            title: '2. Triceps dips',
            subtitle: 'x50',
            width: '120px',
            height: '45px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-incline-push-ups.json'),
            title: '3. Incline Push-Up',
            subtitle: 'x40',
            width: '120px',
            height: '45px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-walk-out-push-ups-with-shoulder-taps.json'),
            title: '4. Walk-out pushups with shoulder taps',
            subtitle: 'x12',
            width: '120px',
            height: '60px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-to-low-plank.json'),
            title: '5. High-to-low plank',
            subtitle: 'x20',
            width: '120px',
            height: '35px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-triceps-push-ups.json'),
            title: '6. Triceps pushups',
            subtitle: 'x16',
            width: '120px',
            height: '35px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-diagonal-plank.json'),
            title: '7. Diagonal plank',
            subtitle: 'x40',
            width: '120px',
            height: '35px',
          }
        ],
      },
    },
    'Maximum Weight Loss': {
      'mode-time': {
        standart: '12 minutes',
        medium: '16 minutes',
        hard: '22 minutes',
      },
      male: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '1. Jumping',
            subtitle: '1 min',
            width: '120px',
            height: '60px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x12',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-intensity-interval-training.json'),
            title: '3. High-Intensity Interval Training',
            subtitle: '1 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '4. Lunges',
            subtitle: '1 min',
            width: '120px',
            height: '85px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '5. Advanced Step-Ups',
            subtitle: 'x20',
            width: '120px',
            height: '65px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jump-rope.json'),
            title: '6. Jump rope',
            subtitle: '1 min',
            width: '120px',
            height: '65px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '7. Mountain climber',
            subtitle: '1 min',
            width: '120px',
            height: '30px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '1. Jumping',
            subtitle: '75 sec',
            width: '120px',
            height: '60px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x16',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-intensity-interval-training.json'),
            title: '3. High-Intensity Interval Training',
            subtitle: '90 sec',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '4. Lunges',
            subtitle: '75 sec',
            width: '120px',
            height: '85px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '5. Advanced Step-Ups',
            subtitle: 'x24',
            width: '120px',
            height: '65px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jump-rope.json'),
            title: '6. Jump rope',
            subtitle: '90 sec',
            width: '120px',
            height: '65px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '7. Mountain climber',
            subtitle: '90 sec',
            width: '120px',
            height: '30px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jumping.json'),
            title: '1. Jumping',
            subtitle: '90 sec',
            width: '120px',
            height: '60px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x22',
            width: '120px',
            height: '80px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-high-intensity-interval-training.json'),
            title: '3. High-Intensity Interval Training',
            subtitle: '2 min',
            width: '120px',
            height: '40px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-lunges.json'),
            title: '4. Lunges',
            subtitle: '90 sec',
            width: '120px',
            height: '85px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-advanced-step-ups.json'),
            title: '5. Advanced Step-Ups',
            subtitle: 'x30',
            width: '120px',
            height: '65px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-jump-rope.json'),
            title: '6. Jump rope',
            subtitle: '2 min',
            width: '120px',
            height: '65px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/male-exercises/male-mountain-climber.json'),
            title: '7. Mountain climber',
            subtitle: '2 min',
            width: '120px',
            height: '30px',
          }
        ],
      },
      female: {
        standart: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '1. Jumping',
            subtitle: '1 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x12',
            width: '120px',
            height: '75px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-intensity-interval-training.json'),
            title: '3. High-Intensity Interval Training',
            subtitle: '1 min',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '4. Lunges',
            subtitle: '1 min',
            width: '120px',
            height: '65px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '5. Advanced Step-Ups',
            subtitle: 'x20',
            width: '120px',
            height: '70px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jump-rope.json'),
            title: '6. Jump rope',
            subtitle: '1 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '7. Mountain climber',
            subtitle: '1 min',
            width: '120px',
            height: '35px',
          }
        ],
        medium: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '1. Jumping',
            subtitle: '75 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x16',
            width: '120px',
            height: '75px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-intensity-interval-training.json'),
            title: '3. High-Intensity Interval Training',
            subtitle: '90 sec',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '4. Lunges',
            subtitle: '75 sec',
            width: '120px',
            height: '65px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '5. Advanced Step-Ups',
            subtitle: 'x24',
            width: '120px',
            height: '70px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jump-rope.json'),
            title: '6. Jump rope',
            subtitle: '90 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '7. Mountain climber',
            subtitle: '90 sec',
            width: '120px',
            height: '35px',
          }
        ],
        hard: [
          {
            id: 1,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jumping.json'),
            title: '1. Jumping',
            subtitle: '90 sec',
            width: '120px',
            height: '70px',
          },
          {
            id: 2,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-burpees.json'),
            title: '2. Burpees',
            subtitle: 'x22',
            width: '120px',
            height: '75px',
          },
          {
            id: 3,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-high-intensity-interval-training.json'),
            title: '3. High-Intensity Interval Training',
            subtitle: '2 min',
            width: '120px',
            height: '30px',
          },
          {
            id: 4,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-lunges.json'),
            title: '4. Lunges',
            subtitle: '90 sec',
            width: '120px',
            height: '65px',
          },
          {
            id: 5,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-advanced-step-ups.json'),
            title: '5. Advanced Step-Ups',
            subtitle: 'x30',
            width: '120px',
            height: '70px',
          },
          {
            id: 6,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-jump-rope.json'),
            title: '6. Jump rope',
            subtitle: '2 min',
            width: '120px',
            height: '70px',
          },
          {
            id: 7,
            image: require('../pages/WorkoutExercisesPage/img-workout-exercises/female-exercises/female-mountain-climber.json'),
            title: '7. Mountain climber',
            subtitle: '2 min',
            width: '120px',
            height: '35px',
          }
        ],
      },
    }
  },
}